//import store from "../../store/store";
import {db} from "../../services/db";
import TimeStamp from "../timeStamp";
import {firestore} from "../../services/db";
//import SPIELER_CHANGE_HANDLER from "../data/spieler/spielerChangeHandler";

export class FirebaseHandler {

    async saveNew(call, object){
        let parameter = this.getDocumentParameter(call, object, false);
        if ( parameter.withId ) {
            return await this.saveNewWithId(parameter);
        } else {
            return await this.saveNewWithoutId(parameter);
        }
    }

    async saveNewKeyToDocument(call, object){
        let parameter = this.getDocumentParameter(call, object, false);
        return await this.updateDocument(parameter)
    }

    async saveEdited(call, object){
        let parameter = this.getDocumentParameter(call, object, false);
        return await this.updateDocument(parameter)
    }

    async deleteElementKey(call, object) {
        let parameter = this.getDocumentParameter(call, object, true);
        return await this.updateDocument(parameter)
    }

    async updateWithTransaction(call, safe, object) {
        let parameter = this.getDocumentParameter(call, object, false);
        let nrOfChanges = Object.keys(parameter.data).length;
        if ( nrOfChanges === 0  ) {
            return new Promise( (resolve) => {
                resolve({successful: true, content: 'xy'})
            })
        } else {
            if ( safe ) {
                return await this.updateDocumentWithTransactionSafe(parameter)
            } else {
                return await this.updateDocumentWithTransaction(parameter)
            }
        }
    }

    async updateWithTransactionFullCheck(call, object) {
        let parameter = this.getDocumentParameter(call, object, false);
        let nrOfChanges = Object.keys(object.local.documentUpdates).length;
        if ( nrOfChanges === 0  ) {
            return new Promise( (resolve) => {
                resolve({successful: true, content: 'no change'})
            })
        } else {
            return await this.updateDocumentWithTransactionFullCheck(parameter, object)
        }
    }

    async deleteWithTransaction(call, safe, object) {
        let parameter = this.getDocumentParameter(call, object, false);
        if ( safe ) {
            return await this.deleteDocumentWithTransactionSafe(parameter)
        } else {
            //return await this.deleteDocumentWithTransaction(parameter)
        }
    }

    async deleteDocument(call, object) {
        let parameter = this.getDocumentParameter(call, object, false);
        return await this.deleteDBdocument(parameter)
    }

        saveNewWithId( parameter ){
        console.log ("saveNewWithId: ", parameter);
            return new Promise( (resolve) => {
                db.collection(parameter.collection).doc(parameter.docId)
                .set(parameter.data)
                .then(() => {
                    console.log("Document successfully written!");
                    resolve({successful: true, content: parameter.docId})
                })
                .catch((error) => {
                    console.error("Error writing document: ", error);
                    resolve({successful: false, content: error})
                });
            })
        }
        saveNewWithoutId( parameter ){
            console.log ("saveNewWithoutId: ", parameter);
            return new Promise( (resolve) => {
                db.collection(parameter.collection).add(parameter.data)
                    .then((docRef) => {
                        console.log("Document written with ID: ", docRef.id);
                        resolve({successful: true, content: docRef.id})
                    })
                    .catch((error) => {
                        console.error("Error adding document: ", error);
                        resolve({successful: false, content: error})
                    });
            })
        }
        updateDocument(parameter){
            return new Promise( (resolve) => {
                db.collection(parameter.collection).doc(parameter.docId)
                    .update(parameter.data)
                    .then(() => {
                        console.log("Document successfully written!");
                        resolve({successful: true, content: ''})
                    })
                    .catch((error) => {
                        console.error("Error writing document: ", error);
                        resolve({successful: false, content: error})
                    });
            })
        }
        updateDocumentWithTransaction(parameter){
            return new Promise( (resolve) => {
                const sfDocRef = db.collection(parameter.collection).doc(parameter.docId);
                db.runTransaction((transaction) => {
                    return Promise.resolve(
                        transaction.update(sfDocRef, parameter.data)
                    )
                        .then(() => {
                            console.log("Transaction successfully committed!");
                            resolve({successful: true, content: ''})
                        }).catch((error) => {
                            console.log("Transaction failed: ", error);
                            resolve({successful: false, content: error})
                        });
                });
            })
        }
        updateDocumentWithTransactionSafe(parameter){
            return new Promise( (resolve) => {
                const sfDocRef = db.collection(parameter.collection).doc(parameter.docId);
                db.runTransaction(transaction => {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(sfDocRef).then(() => {
                        /*if (!doc.data().bookings) {
                            transaction.set({
                                bookings: [booking]
                            });
                        } else {
                            const bookings = doc.data().bookings;
                            bookings.push(booking);
                            transaction.update(userRef, { bookings: bookings });
                        }*/
                        transaction.update(sfDocRef, parameter.data.delete);
                        transaction.update(sfDocRef, parameter.data.update);
                    });
                }).then(()=> {
                    console.log("Transaction successfully committed!");
                    resolve({successful: true, content: ''})
                }).catch((error)=> {
                    console.log("Transaction failed: ", error);
                    resolve({successful: false, content: error})
                });
            })
        }

        deleteDocumentWithTransactionSafe(params){
            return new Promise( (resolve) => {
                const sfDocRef = db.collection(params.collection).doc(params.docId);
                db.runTransaction(transaction => {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(sfDocRef).then(doc => {
                        if ( params.data.operator === 'equal' ) {
                            if ( doc.data()[params.data.checkField] === params.data.targetValue) {
                                throw "Verification failed!";
                            }
                        } else {
                            let data = doc.data();
                            let keys = params.data.checkField.split('.');
                            keys.forEach( (key) => {
                                data = data[key];
                            });
                            if (data !== params.data.targetValue) {
                                throw "Verification failed!";
                            }
                            /*if (doc.data()[params.data.checkField] !== params.data.targetValue) {
                                throw "Verification failed!";
                            }*/
                        }
                        transaction.delete(doc.ref);
                        //db.collection("cities").doc("DC").delete();
                    });
                }).then(()=> {
                    console.log("Transaction successfully committed!");
                    resolve({successful: true, content: ''})
                }).catch((error)=> {
                    console.log("Transaction failed: ", error);
                    resolve({successful: false, content: error})
                });
            })
        }

        updateDocumentWithTransactionFullCheck(params, object) {
            return new Promise( (resolve) => {
                const sfDocRef = db.collection(params.collection).doc(params.docId);
                db.runTransaction(transaction => {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(sfDocRef).then(doc => {
                        this.verifyObjectKeys(doc.data(), object);
                        /*Object.keys(doc.data()).forEach( (key) => {
                            if ( doc.data()[key] !== object[key] ) { throw "Verification failed!"; }
                        });*/
                        transaction.update(sfDocRef, params.data);
                    });
                }).then(()=> {
                    console.log("Transaction successfully committed!");
                    resolve({successful: true, content: ''})
                }).catch((error)=> {
                    console.log("Transaction failed: ", error);
                    resolve({successful: false, content: error})
                });
            })
        }
            verifyObjectKeys(docData, localData){
                Object.keys(docData).forEach( (key) => {
                    if ( typeof docData[key] === 'object' && docData[key] !== null ) {
                        this.verifyObjectKeys( docData[key], localData[key]);
                    } else {
                        if ( docData[key] !== localData[key] ) {
                            throw "Verification failed!";
                        }
                    }
                });
            }

        deleteDBdocument( parameter ){
            return new Promise( (resolve) => {
                db.collection(parameter.collection).doc(parameter.docId).delete()
                    .then(() => {
                        console.log("Document successfully deleted!");
                        resolve({successful: true, content: parameter.docId})
                    })
                    .catch((error) => {
                        console.error("Error deleting document: ", error);
                        resolve({successful: false, content: error})
                    });
            })
        }
// generic getter support methods
    getIdForDocumentUpdated(parentKey, object){
        return object.id ? parentKey + object.id :
            parentKey + TimeStamp.getGMTTimestamp();
    }


    getDataForDocumentUpdate(object, isKeyDeletion) {
        if ( isKeyDeletion ) {
            return firestore.FieldValue.delete()
        } else {
            return object.getDbObject()
        }
    }

// app specific methods
    getDocumentParameter(call, object){ //, isKeyDeletion
        switch (call) {
            case 'landesverband':
                return {    collection: 'landesverbaende',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'spiel':
                return {    withId: false,
                            collection: 'spiele',
                            data: object.getDbObject(),
                };
            case 'spiel_edit':
                return {    collection: 'spiele',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'vereinsdatenblatt':
                return {    withId: true,
                            docId: object.id,
                            collection: 'vereinsdatenblaetter',
                            data: object.getDbObject(),
                };
            case 'vereinsdatenblatt_edit':
                return {    collection: 'vereinsdatenblaetter',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'saison':
                return {    withId: true,
                            docId: object.id,
                            collection: 'saisonen',
                            data: object.getDbObject(),
                };
            case 'saison_edit':
                return {    collection: 'saisonen',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'spieler':
                return {    withId: false,
                            collection: 'spieler',
                            data: object.getDbObject(),
                };
            case 'spieler_edit':
            case 'spieler_editNew':
                return {    collection: 'spieler',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            /*case 'spieler_status':
                return {    collection: 'spieler',
                            docId: object.id,
                            data: { status: object.status === 'aktiv' ? 'inaktiv' : 'aktiv',
                                letzteAenderung: TimeStamp.getGMTTimestamp(),
                            },
                };*/
            case 'spieler_delete':
                //console.log ("spielerDelete !!!!!!! :", JSON.parse(JSON.stringify(object)) );
                return {    collection: 'spieler',
                            docId: object.id,
                            data: {checkField: 'search.passStatus',
                                    targetValue: 'beantragt', operator: 'not equal'},
                };
            case 'spieler_download_excel':
                //console.log ("spieler_download_excel !!!!!!! :", JSON.parse(JSON.stringify(object)) );
                return {    collection: 'spieler',
                            docId: object.id,
                            data: object.local.documentUpdates//{passNr: 'in Bearbeitung'},
                };
            case 'spieler_delete_private':
                //console.log ("spieler_delete_private !!!!!!! :", JSON.parse(JSON.stringify(object)) );
                return {    collection: 'spieler/' + object.id + "/private",
                            docId: object.id,
                };
            case 'spielerPrivate':
                return {    withId: true,
                            collection: 'spieler/' + object.id + "/private",
                            docId: object.id,
                            data: object.getDbObject(),
                };
            case 'spielerPrivate_edit':
            case 'spielerPrivate_editNew':
                return {    collection: 'spieler/' + object.id + "/private",
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'spielerBestaetigungen':
                return {    collection: 'spieler',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'spielerAction':
                //console.log ("spielerAction !!!!!!! :", JSON.parse(JSON.stringify(object)) );
                return {    withId: false,
                            collection: 'spieler_actions',
                            data: object.getDbObject(),
                };
            case 'spieler_action_lvVerein':
                return {    collection: 'spieler_actions',
                            docId: object.id,
                            data: { status_lvNr: object.status_lvNr,
                                    status_lvVerein: object.status_lvVerein,
                                    status_lvVerein_pending: object.status_lvVerein_pending },
                };
            case 'spieler_action_done':
                //console.log ("spieler_action_done", object.local.documentUpdates);
                return {    collection: 'spieler_actions',
                            docId: object.id,
                            data: JSON.parse(JSON.stringify(object.local.documentUpdates)),
                };
            case 'spielerActions_bestaetigungen':
                return {    collection: 'spieler_actions',
                            docId: object.id,
                            data: object.local.documentUpdates,
                };
            case 'spielerActionDelete':
                //console.log ("spielerActionDelete !!!!!!! :", JSON.parse(JSON.stringify(object)) );
                return {    collection: 'spieler_actions',
                            docId: object.id,
                            data: {checkField: 'processedBy', targetValue: '', operator: 'not equal'},
                };

            default:
                console.error ("Application Error: please setup object definition in method getDocumentParameter!!!");
        }
    }



}